/** @jsxImportSource @emotion/react */
import { useCallback, useEffect, useState } from 'react'
import { debounce } from 'lodash'
import { DEBOUNCE_DELAY } from 'constants/consts'
import { ReactComponent as SearchIcon } from '../Autosuggest/icons/search.svg'
import { Input, InputProps } from './Input'
import * as classes from './styles'

export function Search({ value, onChange, ...props }: InputProps) {
  const [searchInput, setSearchInput] = useState('')
  const debouncedSearch = useCallback(debounce(onChange, DEBOUNCE_DELAY), [onChange])

  useEffect(() => {
    setSearchInput(value)
  }, [value])

  const handleSearchInputChange = useCallback(
    (value: string) => {
      setSearchInput(value)
      debouncedSearch(value)
    },
    [debouncedSearch]
  )

  return (
    <Input
      value={searchInput}
      onChange={handleSearchInputChange}
      placeholder="Search"
      startAdornment={<SearchIcon css={classes.searchIcon} />}
      {...props}
    />
  )
}
